import React from 'react';
import {observer} from "mobx-react-lite";
import ManagerHome from "../Clubs/Manager/ManagerHome";
import TrainerHome from "../Clubs/Trainer/TrainerHome";
import ParentHome from "../Clubs/Parent/ParentHome";
import PageLayout from '../PageLayout'
import MemberHome from '../Clubs/Member/MemberHome'
import ClubSearchHome from "./ClubSearchHome";

const Client = () => {
  return (
    <PageLayout>
        <ManagerHome/>
        <TrainerHome/>
        <ParentHome/>
        <MemberHome/>
        <ClubSearchHome/>
    </PageLayout>
  );
};

export default observer(Client)